// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddFormMutation($input: AddFormInput!) {
    addForm(input: $input) {
      formEdge {
        node {
          id
          name
          description
          type
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'Forms_forms',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'formEdge',
        },
      ],
    });
  },
};
